import { observable } from 'mobx';
import localForage from 'localforage';

const dbConfig = {
  name: 'scoring',
  driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE],
};

class ConfigStore {
  @observable storage;

  constructor() {
    this.storage = localForage;
    this.storage.config(dbConfig);
  }
}

const configStore = new ConfigStore();

export default configStore;
